import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';



import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
} from 'react-icons/fa';

import { FaMapLocation } from 'react-icons/fa6';

const Footer = () => {

  const [contactInfo, setContactInfo] = useState({
    email: "",
    phone: "",
    address: "",
    address_link: "",
    facebook: "",
    instagram: "",
    twitter: "",
    linkedin: "",
    whatsapp: "",
  });

  // Fetch Contact Details
  useEffect(() => {
    fetch("https://online.funforay.com/admin/api/settings")
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data) {
          setContactInfo({
            email: data.data.email || "",
            phone: data.data.phone || "",
            address: data.data.address || "",
            address_link: data.data.address_link || "",

            facebook: data.data.facebook || "",
            instagram: data.data.instagram || "",
            twitter: data.data.twitter || "",
            linkedin: data.data.linkedin || "",
            whatsapp: data.data.whatsapp || "",
          });
        }
      })
      .catch(() => console.log("Failed to load contact info"));
  }, []);

  return (
    <footer className='footer'>
      <div style={styles.container}>

        {/* Column 1 */}
        <div style={styles.column}>
          <img src={logo} alt="FunForay" style={styles.logo} />
          <p className='footer_text'>
            Funforay started in 2014. Since then, it has been offering quality services 
            of holiday packages, flights, and hotels. You can easily and confidently book
             these services through this website at affordable pricing. Packages are curated by a
             highly experienced team to convert your travel into charming memories.
          </p>

          <div style={styles.socialIcons}>
            {contactInfo.facebook && (
              <a
                className="icon"
                href={contactInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialIcon}
              >
                <FaFacebookF />
              </a>
            )}

            {contactInfo.twitter && (
              <a
                className="icon"
                href={contactInfo.twitter}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialIcon}
              >
                <FaTwitter />
              </a>
            )}

            {contactInfo.instagram && (
              <a
                className="icon"
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialIcon}
              >
                <FaInstagram />
              </a>
            )}

            {contactInfo.linkedin && (
              <a
                className="icon"
                href={contactInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialIcon}
              >
                <FaLinkedinIn />
              </a>
            )}

            {contactInfo.whatsapp && (
              <a
                className="icon"
                href={contactInfo.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.socialIcon}
              >
                <FaWhatsapp />
              </a>
            )}
          </div>
        </div>

        {/* Column 2 */}
        <div style={styles.column}>
          <h4 className='footer_col_title'>Quick Links</h4>
          <ul className='footer_links' style={styles.linkList}>
            <li><Link to="/about" style={styles.link}>About Us</Link></li>
            <li><Link to="/packages" style={styles.link}>Holiday Packages</Link></li>
            <li><Link to="/contact" style={styles.link}>Contact Us</Link></li>
            <li><Link to="/privacy-policy" style={styles.link}>Privacy Policy</Link></li>
            <li><Link to="/terms-conditions" style={styles.link}>Terms & Conditions</Link></li>
            <li><Link to="/user-agreement" style={styles.link}>User Agreement</Link></li>
          </ul>
        </div>

        {/* Column 3 */}
        <div style={styles.column}>
          <h4 className='footer_col_title'>Get In Touch</h4>

          {/* Phone */}
          <div className='footer_contact'>
            <div style={styles.iconBox}><FaPhone /></div>
            <div>
              <p style={{ whiteSpace: "nowrap", display: "flex" }}>
                {contactInfo.phone
                  ? contactInfo.phone.split('/').map((phone, index, arr) => {
                    const cleanPhone = phone.trim();

                    return (
                      <React.Fragment key={index}>
                        <a
                          href={`tel:${cleanPhone.replace(/\s+/g, '')}`}
                          style={styles.link}
                        >
                          {cleanPhone}
                        </a>

                        {index < arr.length - 1 && (
                          <span style={{ margin: "0 5px" }}>/</span>
                        )}
                      </React.Fragment>
                    );
                  })
                  : "Loading..."}
              </p>
            </div>
          </div>

          {/* Email */}
          <div className='footer_contact'>
            <div style={styles.iconBox}><FaEnvelope /></div>
            <div>
              <p><a href={`mailto:${contactInfo.email}`} style={styles.link}>
                {contactInfo.email || "Loading..."}
              </a></p>
            </div>
          </div>

          {/* Address */}
          <div className='footer_contact'>
            <div style={styles.iconBox}><FaMapLocation /></div>
            <div>
              <p style={styles.contactText}>
                <a href={contactInfo.address_link || "#"} target="_blank" rel="noopener noreferrer">
                  {contactInfo.address || "Loading..."}
                </a>
              </p>

            </div>
          </div>
        </div>

        {/* Column 4 */}
        <div style={styles.column}>
          <h4 className='footer_col_title'>Facebook Feed</h4>

          <div style={{ marginTop: "10px" }}>
            <iframe
              title="Facebook Feed"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fyourfunforay&tabs=timeline&width=340&height=260&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="100%"
              height="260"
              style={{ border: "none", overflow: "hidden", borderRadius: "10px" }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>

      </div>
    </footer>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '0 auto',
  },
  column: {
    flex: '1',
    marginBottom: '20px',
    padding: '0 15px',
  },
  logo: {
    width: '240px',
  },
  socialIcons: {
    display: 'flex',
    gap: '10px',
    marginTop: '10px',
  },
  socialIcon: {
    fontSize: '18px',
    color: '#555',
    textDecoration: 'none',
  },
  iconBox: {
    width: '30px',
    marginRight: '10px',
    fontSize: '18px',
  },
  link: {
    color: '#555',
    textDecoration: 'none',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
    marginTop: '10px',
  },
  galleryImage: {
    width: '100%',
    borderRadius: '6px',
    objectFit: 'cover',
  },
};

export default Footer;
